import { render, staticRenderFns } from "./AnimalRelationshipToOtherParty.vue?vue&type=template&id=7557310a"
import script from "./AnimalRelationshipToOtherParty.vue?vue&type=script&lang=ts"
export * from "./AnimalRelationshipToOtherParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports